import { IPurchasablesReducerState } from "@smartrr/shared/entities/Purchasable";
import { IPurchaseStateReducerState } from "@smartrr/shared/entities/PurchaseState";
import { combineReducers } from "redux";

import { CustomerAction, CustomerActionActionType } from "@customer-app/state/typedCustomerRedux";

import { IAddressesReducerState, addressesReducer } from "./addresses";
import { IAuthReducerState, authReducer } from "./auth";
import { IBundleReducerState, bundleReducer } from "./bundle";
import { purchaseStatesReducer } from "./customerPurchaseStates";
import { IInstagramPostsReducerState, instagramPostsReducer } from "./instagram";
import { IModalReducerState, modalReducer } from "./modal";
import { IOrdersReducerState, ordersReducer } from "./orders";
import { purchasablesReducer } from "./purchasables";
import { IRetentionReducerState, retentionReducer } from "./retention";
import { ISellingPlanGroupsReducerState, sellingPlanGroupsReducer } from "./sellingPlanGroups";
import { IThemeReducerState, themeReducer } from "./theme";

const reducersObj = {
  auth: authReducer,
  bundles: bundleReducer,
  theme: themeReducer,
  addresses: addressesReducer,
  purchasables: purchasablesReducer,
  orders: ordersReducer,
  purchaseStates: purchaseStatesReducer,
  sellingPlanGroups: sellingPlanGroupsReducer,
  retention: retentionReducer,
  modal: modalReducer,
  instagramPosts: instagramPostsReducer,
};

// using object ref to eensure equality check failure
const impossibleToEqual = {};

// unsafe but should be harmless
// initialize with default values for each reducer
export const initialState: IPortalState = Object.keys(reducersObj).reduce((accum: any, key: string) => {
  // void 0 will trigger default value
  accum[key] = (reducersObj as any)[key](void 0, { type: impossibleToEqual });
  return accum;
}, {}) as any;

export const rootReducer = combineReducers<IPortalState, CustomerAction<CustomerActionActionType>>(reducersObj);

export interface IPortalState {
  auth: IAuthReducerState;
  bundles: IBundleReducerState;
  theme: IThemeReducerState;
  addresses: IAddressesReducerState;
  purchasables: IPurchasablesReducerState;
  orders: IOrdersReducerState;
  purchaseStates: IPurchaseStateReducerState;
  /**
   * @deprecated use new store here -> src/_state/zustand/sellingPlanGroup/index.ts
   */
  sellingPlanGroups: ISellingPlanGroupsReducerState;
  retention: IRetentionReducerState;
  modal: IModalReducerState;
  instagramPosts: IInstagramPostsReducerState;
}
